import { ApplianceFeatures, VideonInputPort, VideonPortMode } from 'common/api/v1/types'
import { Select } from '../../../common/Form'
import { RichOption } from '../../../common/Form/Select'
import { useEffect, useMemo } from 'react'
import { useFormContext } from 'react-hook-form'

interface VideonPortFormProps {
  namePrefix: string
  applianceFeatures: ApplianceFeatures
  limitToMode?: VideonPortMode
}

const VideonPortForm = ({ namePrefix, limitToMode, applianceFeatures }: VideonPortFormProps) => {
  const { getValues, setValue, watch } = useFormContext()

  const logicalPort: VideonInputPort = getValues(namePrefix)

  const modeKey = `${namePrefix}.mode`
  watch(modeKey)
  const selectedMode = logicalPort.mode as VideonPortMode | ''
  const modeOptions: RichOption[] = useMemo(() => {
    const videonModes = applianceFeatures.input?.modes.filter((m) => m.mode in VideonPortMode) ?? []
    return videonModes.map((m) => {
      const disabled = Boolean(limitToMode && limitToMode != m.mode)
      return {
        name: m.prettyName ?? m.mode,
        value: m.mode,
        disabled,
        tooltip: disabled ? 'All active inputs on a videon appliance must have the same mode' : undefined,
      }
    })
  }, [JSON.stringify(applianceFeatures.input?.modes), limitToMode])

  useEffect(() => {
    const defaultMode = modeOptions.length === 1 ? modeOptions[0].value : ''
    const isValidMode = modeOptions.some((m) => m.value === selectedMode)
    if (!isValidMode && selectedMode !== defaultMode) {
      setValue(modeKey, defaultMode)
    }
  }, [modeKey, setValue, modeOptions, selectedMode])

  return (
    <Select
      label="Mode"
      name={modeKey}
      required
      newLine
      options={modeOptions}
      validators={{
        oneOf: { validValues: new Set(modeOptions.filter((o) => !o.disabled).map((o) => o.value)) },
      }}
    />
  )
}

export default VideonPortForm
